'use strict';

export default {
  SET_MENU(state, items) {
    state.menu = items;
    state.isLoading = false;
  }
};